/**
 * Created by zhangrp on 2018/4/3.
 */

import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbServicerForComnSelect from './ServicerForComnSelect';
Vue.regist(SwbServicerForComnSelect);

//选择服务商公共组件
/**
 * @param self
 * @param showContractServicer 展示合同服务商，不传默认不展示
 * @param showDefServicer 展示默认，不传默认不展示
 * @param showRelServicer 展示备选关联服务商，不传默认不展示
 * @param showOthersServicer 展示备选其他服务商，不传默认不展示
 * @param showAllServicer 展示全部服务商，不传默认展示
 * @param multiSelect 多选框，不传默认多选
 * @param filter 列表过滤条件
 * @param initCheckedItem 单选初始选择项
 * @param initCheckedItems 多选初始选择项
 * @param callback
 */
export function openServicerSelectComnDlg(self, params, callback) {
    let showContract = params.showContract || false;
    let showSearch = params.showSearch || false;
    let showDef = params.showDef || false;
    let servcType = params.servcType;
    let devcGroupId = params.devcGroupId || null;
    let devcDefIds = params.devcDefIds || [];
    let showOrder = params.showOrder || false;
    let showAmbilateralBizRel = params.showAmbilateralBizRel || false;
    let showBizRel = params.showBizRel || false;
    let showAdverseBizRel = params.showAdverseBizRel || false;
    let showNoScoreBizRel = params.showNoScoreBizRel || false;
    let showShieldedBizRel = params.showShieldedBizRel || false;
    let showAll = params.showAll || false;
    let multiSelect = params.multiSelect == null ? true : params.multiSelect;
    let multiSelectDisabled = params.multiSelectDisabled || false;
    let filter = params.filter || {};
    let initCheckedId = params.initCheckedId || null;
    let initCheckedIds = params.initCheckedIds || [];
    let warnMessage = params.warnMessage == null ? true : params.warnMessage; // 警告提示（没有选择提示）
    if(!showContract && !showOrder && !showAmbilateralBizRel && !showBizRel && !showAdverseBizRel && !showNoScoreBizRel && !showShieldedBizRel && !showAll && !showDef && !showSearch) {
        MsgBox.warning("至少展示一种类型的服务商!");
        return;
    }
    let theDlg = Vue.$showDialog({
        title: '服务商 - 选择',
        width: '60%',
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-servicer-for-comn-select :servcType="servcType" :devcGroupId="devcGroupId" :devcDefIds="devcDefIds" :showSearch="showSearch" :showDef="showDef" :showContract="showContract" :showOrder="showOrder" :showAmbilateralBizRel="showAmbilateralBizRel"' +
        ':showBizRel="showBizRel" :showAdverseBizRel="showAdverseBizRel" :showNoScoreBizRel="showNoScoreBizRel" :showShieldedBizRel="showShieldedBizRel"' +
        ':showAll="showAll" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled"  :filter="filter" :initCheckedId="initCheckedId"' +
        ':initCheckedIds="initCheckedIds" :warnMessage = "warnMessage" ref="swb_servicer_for_comn_select"></swb-servicer-for-comn-select>' +
        '</div>',
        data: {
            showSearch: showSearch,
            showDef: showDef,
            showContract: showContract,
            showOrder: showOrder,
            showAmbilateralBizRel: showAmbilateralBizRel,
            showBizRel: showBizRel,
            showAdverseBizRel: showAdverseBizRel,
            showNoScoreBizRel: showNoScoreBizRel,
            showShieldedBizRel: showShieldedBizRel,
            showAll: showAll,
            multiSelect: multiSelect,
            multiSelectDisabled: multiSelectDisabled,
            filter: filter,
            initCheckedId: initCheckedId,
            initCheckedIds: initCheckedIds,
            warnMessage: warnMessage,
            servcType: servcType,
            devcGroupId: devcGroupId,
            devcDefIds: devcDefIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_for_comn_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                let returnData = {};
                returnData.checkedIds = result.checkedIds || [];
                returnData.checkedId = result.checkedId || null;
                returnData.checkedList = result.data || [];
                callback(returnData);
                return true;
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
        },
        methods: {}
    });
}

import SwbDevcInspectFlowSave from './DevcInspectFlowSave';
Vue.regist(SwbDevcInspectFlowSave);

export function saveDevcInspectFlow(id, callbackFunc) {
    let theDlg = Vue.$showDialog({
        title: "设备检验流程 - 添加",
        width: 800,
        height: 700,
        template: '<swb-devc-inspect-flow-save :id="id" ref="swb_devc_inspect_flow_save"></swb-devc-inspect-flow-save>',
        data: {
            id: id,
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_inspect_flow_save.getDlgResult() || {};
            if(result.type == 'info') {
                theDlg.close();
                let devcInspectFlowInfo = result.data || {};
                //
                callbackFunc(devcInspectFlowInfo);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        method: {}
    });
}

import SwbDevcInspectFlowInfo from './DevcInspectFlowInfo';
Vue.regist(SwbDevcInspectFlowInfo);

export function showDevcInspectFlowInfo(id) {
    let theDlg = Vue.$showDialog({
        title: "设备检验流程 - 详情",
        width: 800,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-inspect-flow-info :id="id" ref="swb_devc_inspect_flow_info"></swb-devc-inspect-flow-info>',
        data: {
            id: id,
        },
        okClicked: function () {
        },
        method: {}
    });
}

import SwbDevcInspectFlowListForSelect from './DevcInspectFlowListForSelect';
Vue.regist(SwbDevcInspectFlowListForSelect);

export function devcInspectFlowListForSelect(params, callbackFunc) {
    let checkBox = params['checkBox'] || false;
    let checkedFlowList = params['checkedFlowList'] || [];
    //
    let theDlg = Vue.$showDialog({
        title: "设备检验流程 - 选择",
        width: 1100,
        height: 800,
        template: '<swb-devc-inspect-flow-for-select :checkBox="checkBox" :checkedFlowList="checkedFlowList" ref="swb_devc_inspect_flow_for_select"></swb-devc-inspect-flow-for-select>',
        data: {
            checkBox: checkBox,
            checkedFlowList: checkedFlowList,
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_inspect_flow_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                theDlg.close();
                let resultDate = result.data || {};
                //
                callbackFunc(resultDate);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        method: {}
    });
}

// ============================== 凭单检查项

import SwbDevcMaintCheckItemDetail from './DevcMaintCheckItemDetail';
Vue.regist(SwbDevcMaintCheckItemDetail);

import SwbDevcMaintCheckItemSave from './DevcMaintCheckItemSave';
Vue.regist(SwbDevcMaintCheckItemSave);

import SwbDevcMaintCheckItemSelect from './DevcMaintCheckItemSelect';
Vue.regist(SwbDevcMaintCheckItemSelect);

export function saveDevcMaintCheckItemDlg(id, title, callback) {
    title = title != null ? title : '检查项 - 添加';
    Vue.$showDialog({
        title: title,
        width: 800,
        height: 700,
        template: '<div>' +
        '<swb-check-item-save :id="id" ref="swb_check_item_save"></swb-check-item-save>' +
        '</div>',
        data: {
            id: id,
        },
        okClicked: function () {
            let result = this.$refs.swb_check_item_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

export function devcMaintCheckItemDetailDlg(id, title, callback) {
    title = title != null ? title : '检查项 - 查看';
    Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        template: '<div>' +
        '<swb-check-item-detail :id="id" ref="swb_check_item_detail"></swb-check-item-detail>' +
        '</div>',
        data: {
            id: id,
        },
        okClicked: function () {

        }
    });
}

// 注：  disabledItemIds：  为按照   refSrcId  禁用！！！！！
export function devcMaintCheckItemSelectDlg(multiSelect, initCheckedItem, checkedIds, disabledItemIds, selectOperate, title, callBack) {
    title = (title != null && title != "") ? title : '检查项 - 选择';
    Vue.$showDialog({
        title: title,
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-check-item-list-for-select :multiSelect="multiSelect" :selectOperate="selectOperate" :initCheckedItem="initCheckedItem" :checkedIds="checkedIds" :disabledItemIds="disabledItemIds" ref="swb_check_item_list_for_select"></swb-check-item-list-for-select>' +
        '</div>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            checkedIds: checkedIds,
            selectOperate: selectOperate,
            disabledItemIds: disabledItemIds
        },
        okClicked: function () {
            let result = this.$refs.swb_check_item_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

/**
 *
 * @param multiSelect       // 是否多选
 * @param initCheckedItem   // 单选回显
 * @param checkedIds
 * @param title
 * @param callBack
 */
import SwbDevcMaintProofSelect from './DevcMaintProofSelect';
Vue.regist(SwbDevcMaintProofSelect);
//
export function devcMaintProofForSelectDlg(multiSelect, initCheckedItem, checkedIds, isOperator, title, callBack) {
    title = title != null ? title : '平台保养凭单模板-选择';
    Vue.$showDialog({
        title: title,
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-devc-maint-proof-for-select :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :checkedIds="checkedIds" :isOperator="isOperator" ref="swb_devc_maint_proof_for_select"></swb-devc-maint-proof-for-select>' +
        '</div>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            checkedIds: checkedIds,
            isOperator: isOperator
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_maint_proof_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}
import SwbServcWorkVoucherDispatch from './ServcWorkVoucherDispatch';
Vue.regist(SwbServcWorkVoucherDispatch);
//
export function openServcWorkVoucherDispatchDlg(params, callBack, viewAsginThis) {
    let title = params.title != null ? params.title : '工单-调度';
    let id = params.id;
    if(Utils.isNoB(id)) {
        MsgBox.warning("请选择对应的工单");
        return false;
    }
    Vue.$showDialog({
        title: title,
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-servc-work-voucher-servicer :id="id" :viewAsginThis="viewAsginThis" ref="swb_servc_work_voucher_servicer"></swb-servc-work-voucher-servicer>' +
        '</div>',
        data: {
            id: id,
            viewAsginThis: viewAsginThis
        },
        okClicked: function () {
            let result = this.$refs.swb_servc_work_voucher_servicer.getDlgResult() || {};
            if(result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/rentServc/selectDlg.js
// module id = 94
// module chunks = 1